import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';
import { createAction } from '../../api/production-request-api/index.js';

/**
 * Hook containing mutation function for creating an Action.
 */
export const useCreateAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createAction.
     * @param {Local.ActionMutationInput} input - The inputs for creating the Action.
     */
    mutationFn: (input) => createAction(input),
    onSuccess: () => {
      toast.success('Action created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ACTION_DATA] });
    },
  });
};
